// extracted by mini-css-extract-plugin
export default {"companyContainer":"RK-z","companyImage":"SK-z","container":"TK-z","heading":"UK-z","darkText":"VK-z","smallHeading":"WK-z","darkBackground":"XK-z","whiteBackground":"YK-z"};